import { Component, OnInit, ɵConsole } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LoginComponent } from '../../partials/login/login.component';
import { from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { RendezVous } from '../rendez-vous/rendez-vous.component';
import { ResetpasswordDialog } from '../dialogs-password/resetpassword.component';
import { MessConfirmEmail } from '../dialogs-messages/mess_confirmemail_dialog.component';
import { DialogHTML as HtmlDialog } from '../dialogs-html/dialog-html.component';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { CustomerService } from 'src/app/services/customer.service';
import { StateService } from 'src/app/services/states.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MessValidemail } from '../../views/dialogs-messages/mess_validemail_dialog.component';
import { MessLienExpire } from '../../views/dialogs-messages/mess_lien_expire_dialog.component';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  selectedImageHowto = "assets/image/illu-dl-1.svg";
  selectedCssImageHowTo = "img-dl-1";
  content:any;
  listHowto:any = [];
  datareset: any = "";
  dataconfirm: any = "";
  intervaleCarousel: any;
  timer = 2000;
  data_rdv: any = {
    'url_rdv': null,
    'message_error': null,
  };

    login:string = "";
    password:string = "";
    forgetPass:boolean = false;
    message:string = "";
    messagefalse: string = "";
    invalidmail: boolean = false;
    tokenForMail: any;

    tokenauth = "";
    currentUser:any;

  constructor(
    public dialog: MatDialog,
    public httpClient: HttpClient,  
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private customerService: CustomerService,
    private stateService: StateService,
    private cookies: CookieService,
    private router: Router,
    public _sanitizer: DomSanitizer,
  ) {
    this.dataconfirm = {
      "login" : this.activatedRoute.snapshot.params.login,
      "id" : this.activatedRoute.snapshot.params.id,
      "action" : this.activatedRoute.snapshot.params.action
    };
  }

  ngOnInit() {
    if(location.hash == '#login'){ // #1592
        let dialogRef = this.dialog.open(LoginComponent, {
          height: '55%',
          width: '25%',
          panelClass:'dialog-login'
        })
    }

    if (!this.stateService.user.getValue()) {
        environment.tokenauth = this.cookies.get("Tokenauth");
        if(environment.tokenauth){
            this.appService.getUserByToken(this.tokenauth).subscribe((res) => {
                if(res.result.user){
                    environment.tokencalc = res.result.token_calc;
                    res.result.user.identity.ID = res.result.user.ID;
                    res.result.user.identity.email = res.result.user.connection.email;
                    this.stateService.updateUser(res.result.user.identity);
                    this.currentUser = res.result.user.identity;
                } else {
                    this.router.navigateByUrl("/homepage");
                }
            });
        }
    } else {
        this.currentUser = this.stateService.user.getValue();
    }

    if (this.currentUser) {
        this.router.navigateByUrl("/dossier");
    }

    if(this.dataconfirm.action == "forgetpass"){
      const dialogRef = this.dialog.open(ResetpasswordDialog, {
        width: '100%',
        panelClass:'message-dialog',
        data: this.dataconfirm
      });
    } else if (this.dataconfirm.action == "confirmemail") {
      const dialogRef = this.dialog.open(MessConfirmEmail, {
        width: '100%',
        panelClass:'message-dialog',
        data: this.dataconfirm
      });
    } else if (this.dataconfirm.action == "betaTesteur") {
      this.appService.firstConnectionOdoo(this.dataconfirm.login,this.dataconfirm.id).subscribe((res)=>{

        if (res.result && res.result.error) {
          this.dialog.open(MessLienExpire, {
            width: '100%',
            panelClass: 'message-dialog',
            data: { login: this.dataconfirm.login },
          });
        } else if (res.result) {
          res.result.user.identity.ID = res.result.user.ID;
          res.result.user.identity.email = res.result.user.connection.email;
          this.stateService.updateUser(res.result.user.identity);
          environment.tokenauth = res.result.token;
          environment.tokencsrf = "";
          this.cookies.set("Tokenauth", res.result.token);
          
          this.dataconfirm['isBetaTesteur'] = true;

          this.appService.getEtatClient(this.dataconfirm.login, this.dataconfirm.id).subscribe((res)=>{
            console.log(res);
            if(res.result && res.result.typeerror){ // #2127
              if (res.result.typeerror == "mdp") {
                  window.location.href = "/client/dist/homepage#login"
                  return;
              }
              else {
                let message = "Oups, le compte client n'a pas été trouvé.";
                //if (res.result.typerror == "token")
                //else if (res.result.typerror == "compte")

                const dialogRef = this.dialog.open(ResetpasswordDialog, {
                  width: '100%',
                  panelClass:'message-dialog',
                  data: message
                });
              }
            }
            else {
              const dialogRef = this.dialog.open(ResetpasswordDialog, {
                width: '100%',
                panelClass:'message-dialog',
                data: this.dataconfirm
              });
            }
        })
        } else {
          const dialogRef = this.dialog.open(HtmlDialog, {
            data: 'Erreur Technique, veuillez réessayer ou contacter Cobham',
          });
        }
      });
    } else if (this.dataconfirm.action == "firstConnectionOdoo") {
      this.appService.firstConnectionOdoo(this.dataconfirm.login,this.dataconfirm.id).subscribe((res)=>{

        if (res.result && res.result.error) {
          const dialogRef = this.dialog.open(HtmlDialog, {
            data: res.result.error,
          });
        } else if (res.result) {
          res.result.user.identity.ID = res.result.user.ID;
          res.result.user.identity.email = res.result.user.connection.email;
          this.stateService.updateUser(res.result.user.identity);
          environment.tokenauth = res.result.token;
          environment.tokencsrf = "";
          this.cookies.set("Tokenauth", res.result.token);

          this.router.navigateByUrl("/homepage");
        } else {
          const dialogRef = this.dialog.open(HtmlDialog, {
            data: 'Erreur Technique, veuillez réessayer ou contacter Cobham',
          });
        }
      });
    }
    // this.httpClient.get('assets/content-home.json?v='+window['cobham_version']).subscribe((res) => {
    //   this.content = res;
    //   this.listHowto = res["howto"];
    //   this.intervaleCarousel = setInterval(() => {this.updateCarousel()}, this.timer);
    // });
    
    // Défilement automatiques étapes "Comment ça marche"
    

    //Modifie design si zoom ++
    window.addEventListener("resize",()=>{
      //console.log('zoom', this.getDevicePixelRatio())
      let zoom = this.getDevicePixelRatio();
      if(zoom >= 1.2 && (<HTMLElement>document.querySelector('.home'))){
        (<HTMLElement>document.querySelector('.home')).classList.add('zoom-1-25');
        if(zoom >= 1.5 && (<HTMLElement>document.querySelector('.home'))){
          (<HTMLElement>document.querySelector('.home')).classList.add('zoom-1-5');
          if(zoom >= 1.7 && (<HTMLElement>document.querySelector('.home'))){
            (<HTMLElement>document.querySelector('.home')).classList.add('zoom-1-75');
          }else if((<HTMLElement>document.querySelector('.home')) && (<HTMLElement>document.querySelector('.home')).classList.contains('zoom-1-75')){
            (<HTMLElement>document.querySelector('.home')).classList.remove('zoom-1-75');
          }
        }else if((<HTMLElement>document.querySelector('.home')) && (<HTMLElement>document.querySelector('.home')).classList.contains('zoom-1-5')){
          (<HTMLElement>document.querySelector('.home')).classList.remove('zoom-1-5');
        }
      }else if((<HTMLElement>document.querySelector('.home')) && (<HTMLElement>document.querySelector('.home')).classList.contains('zoom-1-25')){
        (<HTMLElement>document.querySelector('.home')).classList.remove('zoom-1-25');
      }
    })
    
    this.customerService.getUrlRendezVous().subscribe((res) => {
        if (typeof(res.result) == "object" && 'error' in res.result) {
          this.data_rdv['message_error'] = res.result.error;
        } else if (typeof(res.result) == "string") {
          this.data_rdv['url_rdv'] = this._sanitizer.bypassSecurityTrustResourceUrl(res.result);
        }
    });
  }

  openRendezVous(){
    const dialogRef = this.dialog.open(RendezVous, {
      width: '100%',
      panelClass: 'rendez-vous',
      data: this.data_rdv
    });
  }

  updateCarousel(){
    let howtoStep = document.querySelector('.howto-steps');
    if(howtoStep && howtoStep.children ){
      for(let i=0;i< howtoStep.children.length;i++){
        if(howtoStep.children[i].classList.contains("select")){
          if(howtoStep.children[i+1]){
            this.changeImage(this.listHowto["items"][i+1])
          }else{
            this.changeImage(this.listHowto["items"][0])
          }
          break;
        }
      }
    }
  }

  changeImage(itemList: any) {
    for(let element of this.listHowto.items){
      element.selected = false;
      if(element == itemList){
        element.selected = true;
      }
    };
    itemList.selected = true;
    this.selectedImageHowto = itemList.url;
    this.selectedCssImageHowTo = itemList.classImg;
    clearInterval(this.intervaleCarousel);
    this.intervaleCarousel = setInterval(() => {this.updateCarousel()}, this.timer);
  }
  
  getDevicePixelRatio() {
    let mediaQuery;
    // console.log(window.matchMedia,window.devicePixelRatio)
    if (window.devicePixelRatio !== undefined) {
        return window.devicePixelRatio;
    } else if (window.matchMedia) {
        mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
          (min--moz-device-pixel-ratio: 1.5),\
          (-o-min-device-pixel-ratio: 3/2),\
          (min-resolution: 1.5dppx)";
        if (window.matchMedia(mediaQuery).matches) {
            return 1.5;
        }
        mediaQuery = "(-webkit-min-device-pixel-ratio: 2),\
          (min--moz-device-pixel-ratio: 2),\
          (-o-min-device-pixel-ratio: 2/1),\
          (min-resolution: 2dppx)";
        if (window.matchMedia(mediaQuery).matches) {
            return 2;
        }
        mediaQuery = "(-webkit-min-device-pixel-ratio: 0.75),\
          (min--moz-device-pixel-ratio: 0.75),\
          (-o-min-device-pixel-ratio: 3/4),\
          (min-resolution: 0.75dppx)";
        if (window.matchMedia(mediaQuery).matches) {
            return 0.7;
        }
    } else {
        return 1;
    }
  }


    // Login
    connexion() {
        console.warn("dans connexion forgetPass -> ", this.forgetPass);
        window['tryga']('send', 'event', 'connexion', 'connexion', '', '');
        if (this.forgetPass == false) {
            this.appService.getConnectToken().subscribe((res) => {
                environment.tokencsrf = res.result.token;
                this.logIn();
            }); 
        } else {
            this.forgetPassword(2);
        }
    }
    
    logIn() {
        this.appService.login(this.login, this.password).subscribe((res) => {
            if(res.result.connect && res.result.connect === "OK") {
                environment.tokenauth = res.result.token;
                res.result.user.credits = res.result.credits;
                res.result.user.identity.ID = res.result.user.ID;
                this.stateService.updateUser(res.result.user.identity);
                environment.tokencsrf = "";
                console.log('TOKEN ==>', res)
                environment.tokencalc = res.result.token_calc;
                this.cookies.set("Tokenauth", res.result.token);
                this.router.navigateByUrl("/dossier");
            } else if(res.result.message) {
                this.messagefalse = res.result.message;
                if(res.result.invalidmail && res.result.token){
                    this.invalidmail = res.result.invalidmail;
                    this.tokenForMail = res.result.token;
                }
            }
        });
    }

    sendMailValid(){
        this.appService.confirmEmail(this.login, this.tokenForMail).subscribe((response)=>{
            this.messagefalse = "";
            this.invalidmail = false;
            let mess = ""
            if(response.success == false){
                mess = response.message;
            }
            const dialogRef = this.dialog.open(MessValidemail, {
                width: '100%',
                panelClass:'message-dialog',
                data: {
                    "email": this.login,
                    "message" : mess
                }
            });
            // dialogRef.afterClosed().subscribe(result => {
            //     this.router.navigateByUrl("/homepage");
            // });
        });
    }
    
    forgetPassword(step){
        if(step === 1){
            this.forgetPass = true;
        } else if(step === 2) {
            window['tryga']('send', 'event', 'connexion', 'mot_de_passe_oublie', '', '');
            this.appService.forgetpass(this.login).subscribe((response)=> {
                if(response && response.success){
                    this.message = "Un email vient de vous être envoyé.";
                } else if(response && response.message) {
                    this.message =  response.message;
                    console.log("Erreur envoie mail mot de passe : ",response.log)
                } else {
                    this.message ="Une erreur est survenue. Veuillez réessayer.";
                }
            })
        }
    }
}
